import axios from 'axios';
import { sharedGet } from '@/lib/sharedGet';
import { formatDate } from '@/utils/datetime';

// NAS Archive API client — completely separate from dmsApi.js. Talks only to
// /api/dms/nas/*. The global axios interceptor attaches auth.
const API = `${process.env.REACT_APP_BACKEND_URL}/api/dms/nas`;

export const nasApi = {
  meta: () => sharedGet(`${API}/meta`),
  status: () => axios.get(`${API}/status`).then((r) => r.data),
  roots: () => axios.get(`${API}/roots`).then((r) => r.data),
  tree: (rootId, nodeId) => sharedGet(`${API}/tree`, {
    params: { root_id: rootId, ...(nodeId ? { node_id: nodeId } : {}) }, ttl: 3000,
  }),
  fileDetail: (nodeId) => axios.get(`${API}/files/${nodeId}`).then((r) => r.data),
  // 元の場所（Windows表記）を取得。監査ログ OPEN_FILE_LOCATION が記録される。
  fileLocation: (nodeId, lan) => axios.post(`${API}/files/${nodeId}/location`, { lan: !!lan })
    .then((r) => r.data),
  search: (q, rootId) => axios.get(`${API}/search`, {
    params: { q, ...(rootId ? { root_id: rootId } : {}) },
  }).then((r) => r.data),
  changes: () => axios.get(`${API}/changes`).then((r) => r.data),
  previewBlobUrl: async (nodeId) => {
    const r = await axios.get(`${API}/files/${nodeId}/preview`, { responseType: 'blob' });
    return { url: URL.createObjectURL(r.data), mime: r.headers['content-type'] };
  },
  download: async (nodeId, filename) => {
    const r = await axios.get(`${API}/files/${nodeId}/download`, { responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement('a');
    a.href = url; a.download = filename || 'file'; a.click();
    URL.revokeObjectURL(url);
  },
  // admin
  getFlags: () => axios.get(`${API}/admin/flags`).then((r) => r.data),
  putFlags: (flags) => axios.put(`${API}/admin/flags`, { flags }).then((r) => r.data),
  createRoot: (b) => axios.post(`${API}/admin/roots`, b).then((r) => r.data),
  updateRoot: (id, b) => axios.put(`${API}/admin/roots/${id}`, b).then((r) => r.data),
  dryRun: (rootId, subtree) => axios.post(`${API}/admin/dry-run`, {}, {
    params: { root_id: rootId, subtree: subtree || '' },
  }).then((r) => r.data),
  activatePilot: (b) => axios.post(`${API}/admin/activate-pilot`, b).then((r) => r.data),
  rescan: (rootId, subtree) => axios.post(`${API}/admin/rescan`, {}, {
    params: { root_id: rootId, subtree: subtree || '' },
  }).then((r) => r.data),
  reconcile: (rootId) => axios.post(`${API}/admin/reconcile`, {}, {
    params: { root_id: rootId },
  }).then((r) => r.data),
  jobControl: (jobId, action) => axios.post(`${API}/admin/jobs/${jobId}/${action}`).then((r) => r.data),
  getWindowsPaths: () => axios.get(`${API}/admin/windows-paths`).then((r) => r.data),
  putWindowsPaths: (b) => axios.put(`${API}/admin/windows-paths`, b).then((r) => r.data),
};

export const fmtSize = (n) => {
  if (n == null) return '—';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
};

export const fmtDate = (iso) => {
  if (!iso) return '—';
  return formatDate(iso) || String(iso).slice(0, 10);
};
